export const dataModuleEntityId = {
  type: 'number',
};
